import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import axios from 'axios';

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';

import Swal from 'sweetalert2'
import $ from 'jquery';

import {
    MaskedInput
    , Input
    , InputGroup
    , Button
    , Stack
    , VStack
    , SelectPicker
    , IconButton
    , Text
    , Loader
} from 'rsuite';

// Thai Date Picker
import { ThaiDatePicker } from 'thaidatepicker-react';

export default class FormRegisterPage extends Component {

    constructor(props) {
        super(props);
        this.state = {
            content: null,
            visible: false,
            confirmVisible: false,
            provinces: [],
            amphures: [],
            tambons: [],
            villages: [],
            prefix: '',
            first_name: '',
            last_name: '',
            date_of_birth: '',
            house_number: '',
            village_no: '',
            village: '',
            village_name: '',
            province: '',
            province_id: 0,
            amphur: '',
            amphur_id: 0,
            tambon: '',
            tambon_id: 0,
            phone: '',
            id_card_number: '',
            email: '',
            password: '',
            confirm_password: ''
        };
    }

    async componentDidMount() {
        await this.onRenderContent({ mode: 'read' })
    }

    promisedSetState = (newState) => {
        return new Promise(resolve => this.setState(newState, resolve));
    };

    fetchVillages = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API}/villages`);
            const data = response.data.map(village => ({
                label: village.name, // Display name in the dropdown
                value: village.name    // Value for the selection
            }));

            // Add the "Other" option at the end of the list
            data.push({
                label: 'อื่นๆ (โปรดระบุ)',
                value: 'other'  // The value for the "Other" option
            });

            // Update the state with the villages data
            await this.promisedSetState({ villages: data });
        } catch (error) {
            console.error("Error fetching villages:", error);
        }
    };

    fetchProvinces = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API}/provinces`);
            const provinces = response.data.map(province => ({
                label: province.name_th,
                value: province.id
            }));
            await this.promisedSetState({ provinces: provinces });
        } catch (error) {
            console.error('Error fetching provinces:', error);
        }
    };

    fetchAmphures = async (amphureKey, tambonKey, provinceId) => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API}/amphures/${provinceId}`);
            const amphuresData = response.data.map(amphure => ({
                label: amphure.name_th,
                value: amphure.id
            }));
            await this.promisedSetState({ [amphureKey]: amphuresData, [tambonKey]: [] }); // Reset tambons
        } catch (error) {
            console.error('Error fetching amphures:', error);
        }
    };

    fetchTambons = async (tambonKey, amphureId) => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API}/tambons/${amphureId}`);
            const tambonsData = response.data.map(tambon => ({
                label: tambon.name_th,
                value: tambon.id
            }));
            await this.promisedSetState({ [tambonKey]: tambonsData });
        } catch (error) {
            console.error('Error fetching tambons:', error);
        }
    };

    handleProvinceChange = async ({ value, mode, amphureKey, tambonKey }) => {
        try {
            await this.fetchAmphures(amphureKey, tambonKey, value);
            await this.onRenderContent({ mode });
        } catch (error) {
            console.error('Error handling province change:', error);
        }
    };

    handleAmphureChange = async ({ value, tambonKey }) => {
        try {
            await this.fetchTambons(tambonKey, value);
            await this.onRenderContent({ mode: 'read' });
        } catch (error) {
            console.error('Error handling amphure change:', error);
        }
    };

    to2decimal = (value) => {
        return `${(value * 1).toFixed(2).replace(/\d{1,3}(?=(\d{3})+(\.\d*)?$)/g, '$&,')}`
    }

    toInterger = (value) => {
        return `${(value * 1).toFixed(0).replace(/\d{1,3}(?=(\d{3})+(\.\d*)?$)/g, '$&,')}`
    }

    onRenderContent = async ({ mode }) => {
        if (mode === 'read') {
            await this.fetchProvinces()
            await this.fetchVillages()
            await this.promisedSetState({
                content: <Container>
                    <Row style={{ marginTop: '1em' }}>
                        <Col className='text-center'>
                            <Text weight="bold">
                                สมัครสมาชิก
                            </Text>
                        </Col>
                    </Row>

                    <Row className="justify-content-center mt-3">
                        <Col md={12} lg={10}>
                            <Card border="light" className='shadow-sm'>
                                <Card.Header className='text-white' style={{ backgroundColor: '#8a0a0a' }}></Card.Header>
                                <Card.Body>
                                    {/* ข้อความแจ้งเตือน PDPA */}
                                    <div style={{ backgroundColor: '#f2f2f2', padding: '15px', borderRadius: '5px', marginBottom: '20px' }}>
                                        <strong>แจ้งเตือนข้อมูลความเป็นส่วนตัว (PDPA)</strong>
                                        <p style={{ marginTop: '10px', marginBottom: '0' }}>
                                            ข้อมูลที่ท่านกรอกในแบบฟอร์มนี้ จะถูกใช้เฉพาะเพื่อการสมัครเข้าใช้งานระบบเท่านั้น
                                            และไม่นำไปใช้เพื่อวัตถุประสงค์อื่นใด ไม่ว่ากรณีใด ๆ โดยไม่ได้รับความยินยอมจากท่าน
                                        </p>
                                    </div>
                                    <Card.Text>
                                        <Row>
                                            <Col>
                                                <VStack>
                                                    <label>1. คำนำหน้า <span style={{ color: 'red' }}>*</span></label>
                                                    <SelectPicker
                                                        className='Shakl'
                                                        size='md'
                                                        data={[
                                                            { value: 'นาย', label: 'นาย' },
                                                            { value: 'นางสาว', label: 'นางสาว' }
                                                        ]}
                                                        searchable={false}
                                                        style={{ width: 180 }}
                                                        placeholder="กรุณาเลือกรายการ"
                                                        onChange={e => this.setState({ prefix: e })}
                                                    />
                                                </VStack>
                                            </Col>
                                        </Row>
                                        <Row className='mt-3'>
                                            <Col>
                                                <VStack>
                                                    <label>2. ชื่อ <span style={{ color: 'red' }}>*</span></label>
                                                    <Input
                                                        className='f0Fva'
                                                        size='sm'
                                                        onChange={e => this.setState({ first_name: e })} />
                                                </VStack>
                                            </Col>
                                        </Row>
                                        <Row className='mt-3'>
                                            <Col>
                                                <VStack>
                                                    <label>3. นามสกุล <span style={{ color: 'red' }}>*</span></label>
                                                    <Input
                                                        className='48IO1'
                                                        size='sm'
                                                        onChange={e => this.setState({ last_name: e })} />
                                                </VStack>
                                            </Col>
                                        </Row>
                                        <Row className='mt-3'>
                                            <Col>
                                                <VStack>
                                                    <label>4. วัน/เดือน/ปี เกิด <span style={{ color: 'red' }}>*</span></label>
                                                    <div className='6a0dV' style={{ display: 'flex', alignItems: 'center' }}>
                                                        <ThaiDatePicker
                                                            placeholder="วัน/เดือน/ปี พ.ศ."
                                                            value={this.state.date_of_birth}
                                                            inputProps={{
                                                                style: {
                                                                    padding: '6px 8px',
                                                                    borderRadius: '6px 0 0 6px',
                                                                    border: '1px solid #E7E5E4',
                                                                    width: '200px',
                                                                }
                                                            }}
                                                            onChange={async (e) => {
                                                                await this.promisedSetState({ date_of_birth: e });
                                                                this.onRenderContent({ mode: 'read' });
                                                            }}
                                                            onClean={async () => {
                                                                await this.promisedSetState({ date_of_birth: '' });
                                                                this.onRenderContent({ mode: 'read' });
                                                            }}
                                                        />
                                                        <IconButton
                                                            icon={<i className="bi bi-calendar3"></i>}
                                                            size="md"
                                                            style={{
                                                                borderRadius: '0 6px 6px 0', // top-left 0, top-right 6px, bottom-right 6px, bottom-left 0
                                                            }}
                                                        />
                                                    </div>
                                                </VStack>
                                            </Col>
                                        </Row>
                                        <Row className='mt-3'>
                                            <label className='mb-2'>5. ที่อยู่ตามทะเบียนบ้าน <span style={{ color: 'red' }}>*</span></label>
                                            <Stack wrap spacing={10}>
                                                <VStack>
                                                    <label>บ้านเลขที่</label>
                                                    <Input
                                                        className='ArEz8'
                                                        size='sm'
                                                        style={{ width: 90 }}
                                                        aria-label="บ้านเลขที่"
                                                        onChange={e => this.setState({ house_number: e })} />
                                                </VStack>
                                                <VStack>
                                                    <label>หมู่ที่</label>
                                                    <Input
                                                        className='af9Bp'
                                                        size='sm'
                                                        style={{ width: 60 }}
                                                        aria-label="หมู่ที่"
                                                        onChange={e => this.setState({ village_no: e })} />
                                                </VStack>
                                                <VStack>
                                                    <label>หมู่บ้าน</label>
                                                    <SelectPicker
                                                        className='DDSDz'
                                                        size='lg'
                                                        placeholder='กรุณาเลือก'
                                                        data={this.state.villages}
                                                        style={{ width: 200 }}
                                                        onChange={async e => {
                                                            await this.promisedSetState({ village: e })
                                                            await this.onRenderContent({ mode: mode })
                                                        }}
                                                    />
                                                </VStack>
                                                {this.state.village === 'other' && (
                                                    <VStack>
                                                        <label>โปรดระบุ (ชื่อหมู่บ้าน)</label>
                                                        <Input
                                                            className='YPaCV'
                                                            size='sm'
                                                            style={{ width: 200 }}
                                                            onChange={e => this.setState({ village_name: e })}
                                                        />
                                                    </VStack>
                                                )}
                                                <VStack>
                                                    <label>จังหวัด</label>
                                                    <SelectPicker
                                                        className='ZXgz3'
                                                        size='lg'
                                                        placeholder='กรุณาเลือก'
                                                        data={this.state.provinces}
                                                        style={{ width: 200 }}
                                                        onSelect={async (v, i) => {
                                                            await this.promisedSetState({ province: i.label, province_id: i.value })
                                                            await this.handleProvinceChange({
                                                                value: i.value,
                                                                mode: 'read',
                                                                amphureKey: 'amphures',
                                                                tambonKey: 'amphurs'
                                                            })
                                                        }}
                                                    />
                                                </VStack>
                                                <VStack>
                                                    <label>อำเภอ</label>
                                                    <SelectPicker
                                                        className='2q7wZ'
                                                        size='lg'
                                                        placeholder='กรุณาเลือก'
                                                        data={this.state.amphures}
                                                        style={{ width: 200 }}
                                                        onSelect={async (v, i) => {
                                                            await this.promisedSetState({ amphur: i.label, amphur_id: i.value })
                                                            await this.handleAmphureChange({
                                                                value: i.value,
                                                                mode: 'read',
                                                                tambonKey: 'tambons'
                                                            })
                                                        }}
                                                    />
                                                </VStack>
                                                <VStack>
                                                    <label>ตำบล</label>
                                                    <SelectPicker
                                                        className='SGODP'
                                                        size='lg'
                                                        placeholder='กรุณาเลือก'
                                                        data={this.state.tambons}
                                                        style={{ width: 200 }}
                                                        onSelect={async (v, i) => await this.promisedSetState({ tambon: i.label, tambon_id: i.value })} />
                                                </VStack>
                                            </Stack>
                                        </Row>
                                        <Row className='mt-3'>
                                            <Col>
                                                <VStack>
                                                    <label>6. เบอร์โทรศัพท์ติดต่อ <span style={{ color: 'red' }}>*</span></label>
                                                    <Input
                                                        className='FFp7A'
                                                        size='sm'
                                                        aria-label="เบอร์โทรศัพท์"
                                                        onChange={e => this.setState({ phone: e })} />
                                                </VStack>
                                            </Col>
                                        </Row>
                                    </Card.Text>
                                    <Card.Footer style={{ backgroundColor: 'white', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                        <div style={{ display: 'flex', justifyContent: 'flex-start' }}>
                                            <Link to="/">
                                                <Button
                                                    startIcon={<i className="bi bi-box-arrow-in-right"></i>}
                                                    appearance="subtle" >
                                                    กลับหน้าแรก
                                                </Button>
                                            </Link>
                                        </div>
                                        <div style={{ flexGrow: 1, textAlign: 'right' }}>
                                            <Button
                                                endIcon={<i className="bi bi-chevron-right"></i>}
                                                className="me-4"
                                                color="blue"
                                                appearance="primary"
                                                onClick={async () => {
                                                    setTimeout(async () => {
                                                        await this.onConfirm({ form: 'info', mode: 'insert' });
                                                    }, 100);
                                                }} >
                                                ถัดไป
                                            </Button>
                                        </div>
                                    </Card.Footer>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                    <br />
                </Container>
            })
        }
    }

    handleVisible = async () => {
        await this.promisedSetState({ visible: !this.state.visible })
        await this.onUsers({ mode: 'read' })

    }

    handleConfirmVisible = async () => {
        await this.promisedSetState({ confirmVisible: !this.state.confirmVisible })
        await this.onUsers({ mode: 'read' })
    }

    onUsers = async ({ mode }) => {
        if (mode === 'read') {
            await this.promisedSetState({
                content: <Container>
                    <Row style={{ marginTop: '1em' }}>
                        <Col className='text-center'>
                            <Text weight="bold" style={{ fontSize: '1.625rem' }}>
                                สมัครสมาชิก
                            </Text>
                        </Col>
                    </Row>

                    <Row className="justify-content-center mt-3">
                        <Col md={12} lg={5}>
                            <Card border="light" className='shadow-sm'>
                                <Card.Header className='bg-primary text-white'></Card.Header>
                                <Card.Body>
                                    <Card.Text>
                                        <Row>
                                            <Col>
                                                <VStack>
                                                    <label><b>เลขบัตรประชาชน</b> <span style={{ color: 'red' }}>*</span></label>
                                                    <MaskedInput
                                                        className='mt-2 3eMVj'
                                                        size='sm'
                                                        mask={[/[0-9,Gg]/, '-', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/]}
                                                        guide={false}
                                                        showMask={[/[0-9,Gg]/, '-', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/]}
                                                        keepCharPositions={true}
                                                        style={{ letterSpacing: '0.1em' }}
                                                        placeholderChar={'_'}
                                                        onChange={e => this.setState({ id_card_number: e })}
                                                    />
                                                </VStack>
                                            </Col>
                                        </Row>
                                        <Row className='mt-3'>
                                            <Col>
                                                <VStack>
                                                    <label><b>E-mail</b>{' '}<span style={{ color: 'red' }}>*</span></label>
                                                    <Input
                                                        className='2flKg'
                                                        size='sm'
                                                        onChange={e => this.setState({ email: e })} />
                                                </VStack>
                                            </Col>
                                        </Row>
                                        <Row className='mt-3'>
                                            <Col>
                                                <VStack>
                                                    <label><b>รหัสผ่าน</b> <span style={{ color: 'red' }}>*</span></label>
                                                    <InputGroup size='lg' inside style={{ width: 300 }}>
                                                        <Input
                                                            className='1x8J4'
                                                            type={this.state.visible ? 'text' : 'password'}
                                                            defaultValue={this.state.password}
                                                            onChange={e => this.setState({ password: e })} />
                                                        <InputGroup.Button onClick={this.handleVisible}>
                                                            {this.state.visible ? <i className="bi bi-eye"></i> : <i className="bi bi-eye-slash"></i>}
                                                        </InputGroup.Button>
                                                    </InputGroup>
                                                </VStack>
                                            </Col>
                                        </Row>
                                        <Row className='mt-3'>
                                            <Col>
                                                <VStack>
                                                    <label><b>ยืนยันรหัสผ่าน</b> <span style={{ color: 'red' }}>*</span></label>
                                                    <InputGroup size='lg' inside style={{ width: 300 }}>
                                                        <Input
                                                            className='ZJwLb'
                                                            type={this.state.confirmVisible ? 'text' : 'password'}
                                                            defaultValue={this.state.confirm_password}
                                                            onChange={e => this.setState({ confirm_password: e })} />
                                                        <InputGroup.Button onClick={this.handleConfirmVisible}>
                                                            {this.state.confirmVisible ? <i className="bi bi-eye"></i> : <i className="bi bi-eye-slash"></i>}
                                                        </InputGroup.Button>
                                                    </InputGroup>
                                                </VStack>
                                            </Col>
                                        </Row>
                                        <Row className='mt-3'>
                                            <Col sm>
                                                <Text color="red">- รหัสผ่านประกอบด้วยตัวอักษรภาษาอังกฤษ ตัวเลข และสัญลักษณ์เท่านั้น</Text>
                                                <Text color="red">- รหัสผ่านต้องมีความยาวระหว่าง 6 ถึง 18 ตัวอักษร</Text>
                                                <Text color="red">- รหัสผ่านต้องมีหมายเลขอย่างน้อยหนึ่งตัว</Text>
                                                <Text color="red">- รหัสผ่านต้องมีสัญลักษณ์อย่างน้อยหนึ่งตัว</Text>
                                            </Col>
                                        </Row>
                                    </Card.Text>
                                    <Card.Footer style={{ backgroundColor: 'white', display: 'flex', justifyContent: 'center' }}>
                                        <Button
                                            startIcon={<i className="bi bi-send-fill"></i>}
                                            className="me-4"
                                            color="green"
                                            appearance="primary"
                                            onClick={() => this.onConfirm({ form: 'user', mode: 'insert' })} >
                                            ส่งข้อมูล
                                        </Button>
                                    </Card.Footer>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                    <br />
                </Container>
            })
        }
    }

    validateIDCardNumber = async (params, clss, cond) => {
        try {
            // Simulate an asynchronous operation (e.g., a network request or delay)
            await new Promise(resolve => setTimeout(resolve, 100)); // Simulating a 100ms delay

            // Remove all hyphens
            const rawValue = params.replace(/-/g, '');  // Removes hyphens

            // Validate the ID card number: it must start with a letter followed by 12 digits
            if (rawValue.length !== 13) {
                // If the ID card number doesn't match the expected format
                $('.' + clss).addClass("required");

                // Display an alert using SweetAlert
                Swal.fire({
                    title: "กรุณากรอกข้อมูลเลขบัตรประชาชน 13 หลัก",
                    icon: "warning",
                    timer: 2000,
                    timerProgressBar: true,
                    confirmButtonText: `<div style="font-size: 1.425rem">ตกลง</div>`,
                });

                return false; // Return false if validation fails
            } else if (rawValue.length === 13) {
                // If the ID card number is valid (1 letter followed by 12 digits)
                $('.' + clss).removeClass("required");

                return true; // Return true if validation passes
            }
        } catch (error) {
            console.error('Validation error:', error);
            return false; // If something goes wrong, return false as fallback
        }
    };

    // Function to validate a password
    validatePassword = (password) => {
        const minLength = 6;
        const maxLength = 18;
        const hasNumber = /\d/;
        const hasSymbol = /[!@#$%^&*(),.?":{}|<>]/;
        const isEnglishOnly = /^[A-Za-z0-9!@#$%^&*(),.?":{}|<>]+$/;

        if (password.length < minLength || password.length > maxLength) {
            return { valid: false, message: "รหัสผ่านต้องมีความยาวระหว่าง 6 ถึง 18 ตัวอักษร" };
        }
        if (!hasNumber.test(password)) {
            return { valid: false, message: "รหัสผ่านต้องมีหมายเลข\nอย่างน้อยหนึ่งตัว" };
        }
        if (!hasSymbol.test(password)) {
            return { valid: false, message: "รหัสผ่านต้องมีสัญลักษณ์\nอย่างน้อยหนึ่งตัว" };
        }
        if (!isEnglishOnly.test(password)) {
            return { valid: false, message: "รหัสผ่านสามารถประกอบด้วย\nตัวอักษรภาษาอังกฤษ ตัวเลข และสัญลักษณ์เท่านั้น" };
        }
        return { valid: true };
    };

    Validate = async (params, clss, cond) => {
        try {
            // Simulate an asynchronous operation (e.g., a network request or delay)
            await new Promise(resolve => setTimeout(resolve, 100)); // Simulating a 500ms delay

            if (params == cond) {
                // Add 'required' class if condition is met
                $('.' + clss).addClass("required");

                // Display an alert using SweetAlert
                Swal.fire({
                    title: "กรุณากรอกข้อมูลให้ครบถ้วน",
                    icon: "warning",
                    timer: 2000,
                    timerProgressBar: true,
                    confirmButtonText: `<div style="font-size: 1.425rem">ตกลง</div>`,
                });

                return false; // Return false if validation fails
            } else if (params != cond) {
                // Remove 'required' class if condition is not met
                $('.' + clss).removeClass("required");

                return true; // Return true if validation passes
            }
        } catch (error) {
            console.error('Validation error:', error);
            return false; // If something goes wrong, return false as fallback
        }
    };

    onConfirm = async ({ form, mode }) => {
        if (form === 'info' && mode === 'insert') {
            const validateInfo = async () => {
                const validationPromises = [
                    this.Validate(this.state.prefix, 'Shakl', ''),
                    this.Validate(this.state.first_name, 'f0Fva', ''),
                    this.Validate(this.state.last_name, '48IO1', ''),
                    this.Validate(this.state.date_of_birth, '6a0dV', ''),
                    this.Validate(this.state.house_number, 'ArEz8', ''),
                    this.Validate(this.state.village_no, 'af9Bp', ''),
                    this.Validate(this.state.village, 'DDSDz', ''),
                    ...(this.state.village === 'other' ? [
                        this.Validate(this.state.village_name, 'YPaCV', ''),
                    ] : []),
                    this.Validate(this.state.province, 'ZXgz3', ''),
                    this.Validate(this.state.amphur, '2q7wZ', ''),
                    this.Validate(this.state.tambon, 'SGODP', ''),
                    this.Validate(this.state.phone, 'FFp7A', ''),
                ];

                const validationResults = await Promise.all(validationPromises);
                return validationResults.every(result => result === true);
            };

            this.setState({ loading: true });  // Start loading
            if (await validateInfo()) {
                await this.promisedSetState({ content: null });
                await this.onUsers({ mode: 'read' });
            }
            this.setState({ loading: false });  // Stop loading
        }

        if (form === 'user' && mode === 'insert') {
            const validateUser = async () => {
                const validationPromises = [
                    this.Validate(this.state.id_card_number, '3eMVj', ''),
                    this.validateIDCardNumber(this.state.id_card_number, '3eMVj', ''),
                    this.Validate(this.state.email, '2flKg', ''),
                    this.Validate(this.state.password, '1x8J4', ''),
                    this.Validate(this.state.confirm_password, 'ZJwLb', ''),
                ];

                const validationResults = await Promise.all(validationPromises);
                return validationResults.every(result => result === true);
            };

            this.setState({ loading: true });  // Start loading
            if (await validateUser()) {
                try {
                    this.checkpass = true;
                    const usernameResponse = await axios.get(`${process.env.REACT_APP_API}/idcardnumber/${this.state.id_card_number}`);
                    if (usernameResponse.data.count > 0) {
                        $('.3eMVj').addClass("required");
                        Swal.fire({
                            title: "เลขบัตรประชาชนถูกใช้งานแล้ว",
                            html: `<div style="font-size: 1.425rem;">
              หากลืมรหัสผ่าน กรุณาติดต่อเจ้าหน้าที่ทางเพจ<br>
              หรือโทรติดต่อ พี่หยุม <strong>082-758-1119</strong>
           </div>`,
                            icon: "warning",
                            confirmButtonText: `<div style="font-size: 1.425rem">ตกลง</div>`,
                        });
                        this.checkpass = false;
                    } else {
                        $('.3eMVj').removeClass("required");
                        this.checkpass = true;
                    }

                    const passwordValidation = this.validatePassword(this.state.password);
                    if (!passwordValidation.valid) {
                        $('.Bj2BC').addClass("required");
                        Swal.fire({
                            title: passwordValidation.message,
                            icon: "warning",
                            timer: 2000,
                            timerProgressBar: true,
                            confirmButtonText: `<div style="font-size: 1.425rem">ตกลง</div>`,
                        });
                        this.checkpass = false;
                    } else {
                        $('.Bj2BC').removeClass("required");
                    }

                    if (this.state.password !== this.state.confirm_password) {
                        $('.FgQPv').addClass("required");
                        Swal.fire({
                            title: "รหัสผ่านไม่ตรงกัน",
                            icon: "warning",
                            timer: 2000,
                            timerProgressBar: true,
                            confirmButtonText: `<div style="font-size: 1.425rem">ตกลง</div>`,
                        });
                        this.checkpass = false;
                    } else {
                        $('.FgQPv').removeClass("required");
                    }

                    if (this.checkpass === true) {
                        const response = await axios.post(`${process.env.REACT_APP_API}/applicants`, {
                            id_card_number: this.state.id_card_number,
                            email: this.state.email,
                            password: this.state.password,
                            prefix: this.state.prefix,
                            first_name: this.state.first_name,
                            last_name: this.state.last_name,
                            date_of_birth: this.state.date_of_birth,
                            house_number: this.state.house_number,
                            village_no: this.state.village_no,
                            village: this.state.village,
                            village_name: this.state.village_name,
                            province: this.state.province,
                            province_id: this.state.province_id,
                            amphur: this.state.amphur,
                            amphur_id: this.state.amphur_id,
                            tambon: this.state.tambon,
                            tambon_id: this.state.tambon_id,
                            phone: this.state.phone
                        });

                        if (response.data.message === 'successfully') {
                            await this.onSuccess({ mode: 'read' });
                        }
                    }
                } catch (error) {
                    Swal.fire({
                        title: "เกิดข้อผิดพลาด",
                        icon: "error",
                        text: error.message,
                        confirmButtonText: `<div style="font-size: 1.425rem">ตกลง</div>`,
                    });
                }
            }
            this.setState({ loading: false });  // Stop loading
        }
    };

    onSuccess = async ({ mode }) => {
        if (mode === 'read') {
            await this.promisedSetState({
                content: <Container style={{ marginTop: '2em', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', textAlign: 'center' }}>
                    <Text weight='bold'>คุณสมัครสมาชิกเรียบร้อยแล้ว</Text>
                    <Text weight='bold'>กรุณาเข้าสู่ระบบ</Text>
                    <Link to="/">
                        <Button
                            className='mt-3'
                            appearance="primary"
                        >กลับสู่หน้าหลัก</Button>
                    </Link>
                    <br />
                </Container>
            })
        }
    }

    render() {

        const FullPageLoader = () => (
            <div style={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                backgroundColor: 'rgba(255, 255, 255, 0.8)', // Semi-transparent background
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                zIndex: 9999 // Ensure it's on top of other content
            }}>
                <Loader content="Loading..." /> {/* Adjust loader component as needed */}
            </div>
        );

        return (
            <>
                {this.state.content}
                {this.state.loading && <FullPageLoader />}
            </>
        );
    }
}
